import HttpInterceptor from "./HttpInterceptor"

const Fetcher = async (url: string)=>{
    try {
        // Disable error toast for SWR fetcher - SWR handles retries and we don't want to spam errors
        // For session endpoint, use validateStatus to prevent 401 from being treated as an error
        // This prevents axios from logging 401 errors to console (they're expected when not logged in)
        const isSessionEndpoint = url.includes('/auth/session');
        const config: any = {
            // @ts-ignore - axios config extension
            showErrorToast: false,
        };
        
        // For session endpoint, accept 401 as valid response (not an error)
        // This prevents axios from logging it to console
        if (isSessionEndpoint) {
            config.validateStatus = (status: number) => {
                // Accept 200-299 and 401 as valid (don't throw error for 401)
                return (status >= 200 && status < 300) || status === 401;
            };
        }
        
        const response = await HttpInterceptor.get(url, config);
        
        // If we got a 401, throw an error so SWR knows the session check failed
        // But axios won't have logged it as an error
        if (isSessionEndpoint && response.status === 401) {
            const error: any = new Error('Unauthorized');
            error.response = response;
            error.response.status = 401;
            throw error;
        }
        
        return response.data;
    } 
    catch (error : any ){
       // For session endpoint 401 errors, they're expected when not logged in
       // Axios won't have logged them because of validateStatus
       // Just throw the error - SWR will handle retries and error states
       throw error
    } 
}

export default Fetcher